import type { AppView } from './registry';

const EXTERNAL = /^([a-z][a-z\d+.-]*:|\/\/|#)/i;

export const isExternalHref = (href: string) => EXTERNAL.test(href);

/** Prefix a canonical path ('/mentions') with a tree base ('' or '/test'). */
export function withBase(basePath: string, href: string): string {
  if (!basePath || EXTERNAL.test(href)) return href;
  if (href === '/') return basePath;
  return `${basePath}${href.startsWith('/') ? '' : '/'}${href}`;
}

/**
 * Analyst modules the executive view hosts under its own prefix — DeepDive AI,
 * the one analyst module executives get (GP, 2026-10-28). Their pages and the
 * library write the analyst paths; from an executive page a link to one stays
 * in the executive view.
 */
export const EXECUTIVE_HOSTED = ['/deepdive-ai'] as const;

/** `/deepdive-ai/abc` → `/executive/deepdive-ai/abc` in the executive view; anything else as it is. */
export function inView(href: string, view: AppView): string {
  if (view !== 'executive' || EXTERNAL.test(href)) return href;
  const hosted = EXECUTIVE_HOSTED.some(
    (path) => href === path || href.startsWith(`${path}/`) || href.startsWith(`${path}?`),
  );
  return hosted ? `/executive${href}` : href;
}
